var render = function render(){var _vm=this,_c=_vm._self._c;return _c('block-storage-list',{attrs:{"id":_vm.id,"getParams":_vm.getParams,"hidenGroupActions":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }